export default "__VITE_ASSET__Dd5YXl9i__"